
import { types } from '../actions/types';

const initialState = {
    fetching: true,
    error: null,
}

export const ui = ( state = initialState, action ) => {
    const newState = { ...state };

    switch ( action.type ) {
        case types.GET_GOOGLE_DFP_REQUEST: return setUiState( newState, action.isFetching, action.error );
        case types.GET_GOOGLE_DFP_ERROR  : return setUiState( newState, action.isFetching, action.error );        
        case types.GET_GOOGLE_DFP_SUCCESS: return setUiState( newState, action.isFetching, action.error );
        default: return newState;
    }
}

function setUiState ( newState, fetching, error ) {
    return { ...newState, fetching, error }
}



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/reducers/ui.js